import { render, staticRenderFns } from "./PlanCardBoxes.vue?vue&type=template&id=312b0732&"
import script from "./PlanCardBoxes.vue?vue&type=script&lang=js&"
export * from "./PlanCardBoxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports